<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-07-25 16:52:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-14 11:43:01
-->
<template>
  <div class="full_page_grey b-s">
    <van-tabs sticky v-model="activeName" @click="topHandle">
      <van-tab :title="ticketCount + '张票券可用'" name="ticket">
        <ticketListCom
          ref="ticketListRef"
          @setTicketCount="handleSetTicketCount"
        ></ticketListCom>

        <!-- <gNoContent
          v-if="couponList.length === 0"
          title="暂无可用票券"
        ></gNoContent> -->
      </van-tab>
      <van-tab :title="couponCount + '张优惠券可用'" name="discount">
        <couponListComp
          ref="couponListRef"
          @setTicketCount="handleSetCouponCount"
        ></couponListComp>

        <!-- <gNoContent
          v-if="couponList.length === 0"
          title="暂无可用优惠券"
        ></gNoContent> -->
      </van-tab>
    </van-tabs>

    <!-- <gBottom></gBottom> -->
  </div>
</template>

<script>
import couponListComp from "@/components/couponListComp";
import ticketListCom from "@/components/ticketListComp";
import { getMyTicketCount } from "@/api/coupon";
export default {
  name: "Index",
  props: {},
  data() {
    return {
      activeName: "ticket",
      // couponList: [{ name: 1 }, { name: 2 }],
      couponList: [],
      cardList: [],
      ticketCount: 0,
      couponCount: 0,
    };
  },
  components: {
    couponListComp,
    ticketListCom,
  },
  created() {},
  watch: {
    "$store.state.vpnId"(val) {
      this.handleGetCouponCount();
      this.$nextTick(() => {
        this.topHandle(this.activeName);
      });
    },
  },
  mounted() {
    if (this.$store.state.vpnId) {
      this.handleGetCouponCount();
      this.$nextTick(() => {
        this.topHandle(this.activeName);
      });
    }
  },
  methods: {
    topHandle(name) {
      this.$nextTick(() => {
        if (name == "ticket") {
          this.$refs.ticketListRef.handleInitGetTicketList();
        } else {
          this.$refs.couponListRef.handleInitGetCouponList();
        }
      });
    },
    handleGetCouponCount() {
      getMyTicketCount({ vpnId: this.$store.state.vpnId }).then((res) => {
        this.ticketCount = res.AvalibleTicketNumber;
        this.couponCount = res.AvalibleCouponNumber;
      });
    },
    handleSetTicketCount(data) {
      this.ticketCount = data;
    },
    handleSetCouponCount(data) {
      this.couponCount = data;
    },
  },
};
</script>
<style scoped lang="scss">
// .container /deep/ .van-tab {
//   width: 250rpx;
// }
</style>
